export const media = {
  sm: '(max-width: 720px)',
  md: '(max-width: 1200px)',
  lg: '(max-width: 1600px)',
  xlg: '(min-width: 1600px)',
}
